import { PDFViewer, Document, Page, View, StyleSheet, Text, Image, Font } from "@react-pdf/renderer";
import { useParams } from 'react-router-dom';
import imgGaruda from '../../assets/images/pngwing.png';
import srcRobotoItalic from '../../assets/custom/font/roboto/Roboto-Italic.ttf';
import { useEffect, useMemo, useState } from "react";
import ViewService from "../../services/view/ViewService";
import { formatDateStringDateFirst } from "../../utilities/Utils.js";
import imgCheckbox from '../../assets/images/icons/checkbox_icon.png';
import imgCheckboxBlank from '../../assets/images/icons/checkbox_blank_outline_icon.png';
import DraftAppendix from "./DraftAppendix";

Font.register({ family: 'Roboto-Italic', src: srcRobotoItalic })

const styles = StyleSheet.create({
    page: {
        paddingTop: 20,
        paddingBottom: 48,
        paddingHorizontal: 48,
        boxSizing: "border-box"
    },
    headingImg: {
        width: 50,
        height: 50,
        marginVertical: 15,
        marginHorizontal: 235,
    },
    headingEn: {
        fontSize: 9,
        textAlign: "center",
        textDecoration: "underline"
    },
    headingIn: {
        fontFamily: "Roboto-Italic",
        fontSize: 9,
        textAlign: "center",
        marginBottom: 3
    },
    table: {
        border: '1 solid black',
        display: 'table',
        width: 'auto',
    },
    tableIdt: {
        borderLeftWidth: 1,
        borderBottom: 1,
        display: 'table',
        width: 'auto',
    },
    tableIdt2: {
        borderBottom: 1,
        display: 'table',
        width: 'auto',
    },
    tableRow: {
        flexDirection: 'row',
    },
    tableCol: {
        width: '100%',
        padding: 3,
        textAlign: 'left',
    },
    tableCol1: {
        width: '50%',
        padding: 5,
        textAlign: 'left',
    },
    tableCol2: {
        width: '50%',
        padding: 5,
        textAlign: 'left',
    },
    tableColIdt1: {
        width: '60%',
        padding: 3,
        textAlign: 'left',
    },
    tableColIdt2: {
        width: '40%',
        padding: 3,
        textAlign: 'left',
    },
    text: {
        fontSize: 7,
        textAlign: "center",
        fontWeight: "bold",
    },
    italicText: {
        fontFamily: "Roboto-Italic",
        fontSize: 7,
        textAlign: "center",
    },
    textEn: {
        fontSize: 8,
        textAlign: "left",
    },
    textIn: {
        fontFamily: "Roboto-Italic",
        fontSize: 8,
        textAlign: "left",
    },
    textBox: {
        fontSize: 9
    },
    checkicon: {
        width: 12,
        height: 12,
    },
    qrCode: {
        alignSelf: "center",
    }
})


const FormH = () => {
    const viewServ = useMemo(() => new ViewService(), [])
    const { noAju } = useParams()
    const [dataHc, setDataHc] = useState(null)
    const [dataPpk, setDataPpk] = useState(null)
    const [dataPpkMutu, setDataPpkMutu] = useState(null)
    const [dataPpkMutuArea, setDataPpkMutuArea] = useState(null)
    const [dataPpkMutuProd, setDataPpkMutuProd] = useState([])
    const [dataPpkContainer, setDataPpkContainer] = useState(null)
    const [dataPpkDetail, setDataPpkDetail] = useState(null)
    const [upt, setUpt] = useState(null)
    const [kdUpt, setKdUpt] = useState(null)
    const [negaraTujuan, setNegaraTujuan] = useState(null)
    const [kdNegaraTujuan, setKdNegaraTujuan] = useState(null)
    const [pelMuat, setPelMuat] = useState(null)
    const [kdPelMuat, setKdPelMuat] = useState(null)
    const [pelBongkar, setPelBongkar] = useState(null)
    const [kdPelBongkar, setKdPelBongkar] = useState(null)
    const [jumlahKemasan, setJumlahKemasan] = useState(null)
    const [uraianKemasan, setUraianKemasan] = useState(null)


    useEffect(() => {
        const fetchAllData = async () => {
            try {
                getHc(noAju);
                getUpt(kdUpt)
                getNegaraTujuan(kdNegaraTujuan)
                getPelabuhanMuat(kdPelMuat)
                getPelabuhanBongkar(kdPelBongkar)
            } catch (error) {
                console.log(error);
            }
        }
        fetchAllData()
    }, [noAju, kdPelMuat, kdPelBongkar, kdNegaraTujuan, kdUpt])

    const getHc = async (noAju) => {
        try {
            const response = await viewServ.getHcByAju(noAju);
            const resPpkDtl = await viewServ.getPpkDtlByAju(noAju);
            const resPpk = await viewServ.getPpkByAju(noAju);
            const resPpkMutu = await viewServ.getPpkMutuByAju(noAju);
            const resPpkMutuArea = await viewServ.getPpkMutuAreaByAju(noAju);
            const resPpkContaier = await viewServ.getPpkContainerByAju(noAju);
            const resPpkMutuProd = await viewServ.getPpkMutuProdByAju(noAju);
            const resJumKemas = await viewServ.getJumlahKemasanByAju(noAju);
            setDataHc(response.data);
            setDataPpk(resPpk.data);
            setDataPpkMutuArea(resPpkMutuArea.data);
            setDataPpkMutu(resPpkMutu.data);
            setDataPpkContainer(resPpkContaier.data);
            setDataPpkMutuProd(resPpkMutuProd.data);
            setDataPpkDetail(resPpkDtl.data);
            setKdUpt(response.data.unit_pusat)
            setKdNegaraTujuan(response.data.kd_ngr_tujuan)
            setKdPelMuat(response.data.pel_asal)
            setKdPelBongkar(response.data.pel_tujuan)
            setJumlahKemasan(resJumKemas.data[0].JUMLAH)
            const resUraianKemasan = await viewServ.getUraianKemasanByKd(resJumKemas.data[0].KODE_KEMASAN);
            setUraianKemasan(resUraianKemasan.data.URAIAN_KEMASAN);
        } catch (error) {
            console.log(error);
            setJumlahKemasan(null)
            setUraianKemasan(null)
        }
    };

    const getUpt = async (kdUpt) => {
        try {
            const response = await viewServ.getUptByAju(kdUpt);
            setUpt(response.data);
        } catch (error) {
            console.log(error);
        }
    };

    const getNegaraTujuan = async (kdNegaraTujuan) => {
        try {
            const response = await viewServ.getNegaraByAju(kdNegaraTujuan);
            setNegaraTujuan(response.data);
        } catch (error) {
            console.log(error);
        }
    };

    const getPelabuhanMuat = async (kdPel) => {
        try {
            const response = await viewServ.getPelabuhanByAju(kdPel);
            setPelMuat(response.data);
        } catch (error) {
            console.log(error);
        }
    };

    const getPelabuhanBongkar = async (kdPel) => {
        try {
            const response = await viewServ.getPelabuhanByAju(kdPel);
            setPelBongkar(response.data);
        } catch (error) {
            console.log(error);
        }
    };

    // let transaksiService = useMemo(() => new TransaksiService(), [])
    // let userService = useMemo(() => new UserService(), [])
    // let masterService = useMemo(() => new MasterService(), [])

    // const [dataHc, setDataHc] = useState(null)
    // const [dataHcDetil, setDataHcDetil] = useState([]) *
    // const [upt, setUpt] = useState(null)
    // const [negaraTujuan, setNegaraTujuan] = useState(null)
    // const [pelMuat, setPelMuat] = useState(null)
    // const [pelBongkar, setPelBongkar] = useState(null)
    // const [ppmDetil, setPpmDetil] = useState([])
    // const [jumlahKemasan, setJumlahKemasan] = useState(null)
    // const [uraianKemasan, setUraianKemasan] = useState(null)
    // const [ppmKontainer, setPpmKontainer] = useState([])
    // const [ppmMutu, setPpmMutu] = useState({})
    // const [ppmMutuArea, setPpmMutuArea] = useState(null)
    // const [ppmMutuProd, setPpmMutuProd] = useState([])

    // useEffect(() => {
    //     if (!datappm) return
    //     const fetchAllData = async () => {
    //         try {
    //             let jsonMutuPK = {
    //                 nomorAju: datappm.nomorAju,
    //                 noProses: dataDisposisi.noTugas
    //             }
    //             const resHc = await transaksiService.getHcMutuById(jsonMutuPK)
    //             setDataHc(resHc.data)

    //             const resUpt = await userService.getUptById(datappm.kdUpt)
    //             // console.log(resUpt)
    //             setUpt(resUpt.data)

    //             const resNeg = await masterService.getNegaraById(datappm.negaraPartner)
    //             setNegaraTujuan(resNeg.data)

    //             const jsonPelMuat = {
    //                 jnsPelabuhan: "D",
    //                 kodePelabuhan: datappm.pelabuhanMuat
    //             }
    //             const resPelDn = await masterService.getPelabuhanById(JSON.stringify(jsonPelMuat))
    //             setPelMuat(resPelDn.data)

    //             const jsonPelLn = {
    //                 jnsPelabuhan: "L",
    //                 kodePelabuhan: datappm.pelabuhanBongkar
    //             }
    //             const resPelLn = await masterService.getPelabuhanById(JSON.stringify(jsonPelLn))
    //             setPelBongkar(resPelLn.data)

    //             // const resDetil = await transaksiService.listPpmDetil(datappm.nomorAju, 0, null, 0, 3)
    //             const resDetil = await transaksiService.listPpmDetilAll(datappm.nomorAju)
    //             setPpmDetil(resDetil.data.data)

    //             const resMutu = await transaksiService.getPpmMutuById(datappm.nomorAju)
    //             setPpmMutu(resMutu.data)

    //             const resMutuArea = await transaksiService.getPpmMutuAreaById(datappm.nomorAju)
    //             setPpmMutuArea(resMutuArea.data)

    //             const resMutuProd = await transaksiService.listPpmMutuProd(datappm.nomorAju, 0, 10)
    //             setPpmMutuProd(resMutuProd.data.data)

    //             const resKemasan = await transaksiService.listPpmKemasan(datappm.nomorAju, 0, 3)
    //             setJumlahKemasan(resKemasan.data.data[0].jumlah)
    //             const resUraianKemasan = await masterService.getKemasanById(resKemasan.data.data[0].kodeKemasan)
    //             setUraianKemasan(resUraianKemasan.data.uraianKemasan)

    //             const resKontainer = await transaksiService.listPpmContainerAll(datappm.nomorAju)
    //             setPpmKontainer(resKontainer.data.data)
    //         } catch (error) {
    //             console.log(error)
    //             setJumlahKemasan(null)
    //             setUraianKemasan(null)
    //         }
    //     }
    //     fetchAllData()
    // }, [datappm, transaksiService, dataDisposisi, masterService, userService])

    return (
        <PDFViewer style={{ width: 1105, height: 800 }}>
            <Document>
                <Page size="LEGAL" style={styles.page}>
                    <View>
                        <Image style={styles.headingImg} src={imgGaruda} />
                        <Text style={styles.headingEn}>THE REPUBLIC OF INDONESIA</Text>
                        <Text style={styles.headingIn}>REPUBLIK INDONESIA</Text>
                    </View>
                    <View>
                        <Text style={styles.headingEn}>MINISTRY OF MARINE AFFAIRS AND FISHERIES</Text>
                        <Text style={styles.headingIn}>KEMENTERIAN KELAUTAN DAN PERIKANAN</Text>
                    </View>
                    <View>
                        <Text style={styles.headingEn}>CERTIFICATE OF QUALITY AND SAFETY FOR FISH AND FISHERY PRODUCT</Text>
                        <Text style={styles.headingIn}>SERTIFIKAT MUTU DAN KEAMANAN HASIL PERIKANAN</Text>
                    </View>
                    <View style={styles.table}>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableColIdt1, { borderRightWidth: 1 }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>Consignor / </Text>
                                    <Text style={styles.textIn}>Pengirim :</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>Name / </Text>
                                    <Text style={styles.textIn}>Nama :</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={[styles.textEn, { paddingLeft: 5 }]}>{dataHc !== null ? dataHc.nm_pengirim : ''}</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>Address / </Text>
                                    <Text style={styles.textIn}>Alamat :</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={[styles.textEn, { paddingLeft: 5 }]}>{dataHc !== null ? dataHc.al_pengirim : ''}</Text>
                                </View>
                            </View>
                            <View style={styles.tableColIdt2}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>Reference Number </Text>
                                    <Text style={styles.textIn}>Nomor Referensi: </Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={[styles.textEn, { paddingLeft: 5 }]}>{dataHc !== null ? dataHc.no_hc_mutu : ''}</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableIdt}>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableColIdt1, { borderRightWidth: 1 }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>Consignee / </Text>
                                    <Text style={styles.textIn}>Penerima : </Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>Name / </Text>
                                    <Text style={styles.textIn}>Nama :</Text>
                                </View>
                                <View style={styles.tableCol}>
                                    <Text style={[styles.textEn, { paddingLeft: 5 }]}>{dataHc !== null ? dataHc.nm_penerima : ''}</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>Address / </Text>
                                    <Text style={styles.textIn}>Alamat :</Text>
                                </View>
                                <View style={styles.tableCol}>
                                    <Text style={[styles.textEn, { paddingLeft: 5 }]}>{dataHc !== null ? dataHc.al_penerima : ''}</Text>
                                </View>
                            </View>
                            <View style={[styles.tableColIdt2, { borderRightWidth: 1 }]}>
                                <View style={styles.tableIdt2}>
                                    <View style={styles.tableRow}>
                                        <Text style={styles.textEn}>Competent Authority / </Text>
                                        <Text style={styles.textIn}>Otoritas Kompeten: </Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.textEn}>MARINE AND FISHERIES QUALITY ASSURANCE AGENCY (MFQAA)</Text>
                                    </View>
                                </View>
                                <View style={[styles.tableIdt2, { borderBottom: 0 }]}>
                                    <View style={styles.tableRow}>
                                        <Text style={styles.textEn}>Certifying Body / </Text>
                                        <Text style={styles.textIn}>Instansi Penerbit Sertifikat: </Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.textEn}>{upt !== null && upt.NM_INGGRIS}</Text>
                                    </View>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableIdt}>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>3. Origin Country of raw Material / </Text>
                                    <Text style={styles.textIn}>Negara Asal Bahan Baku :</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={[styles.textEn, { paddingLeft: 7 }]}>Indonesia</Text>
                                </View>
                            </View>
                            <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>4. Country of Destination / </Text>
                                    <Text style={styles.textIn}>Negara tujuan:</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={[styles.textEn, { paddingLeft: 7 }]}>{negaraTujuan !== null ? negaraTujuan.URAIAN_NEGARA : '-'}</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableIdt}>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>5. Place of dispatch (Port) / </Text>
                                    <Text style={styles.textIn}>Tempat pengeluaran (pelabuhan) :</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={[styles.textEn, { paddingLeft: 7 }]}>{pelMuat !== null ? pelMuat.URAIAN_PELABUHAN : '-'}</Text>
                                </View>
                            </View>
                            <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>6. Port of destination / </Text>
                                    <Text style={styles.textIn}>Pelabuhan tujuan :</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={[styles.textEn, { paddingLeft: 7 }]}>{pelBongkar !== null ? pelBongkar.URAIAN_PELABUHAN : '-'}</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableIdt}>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>7. Means of transport / </Text>
                                    <Text style={styles.textIn}>Alat transport : </Text>
                                    {
                                        dataPpk !== null && dataPpk.MODA === '1' &&
                                        <>
                                            <Text style={styles.textEn}>Ship / </Text>
                                            <Text style={styles.textIn}>Kapal</Text>
                                        </>
                                    }
                                    {
                                        dataPpk !== null && dataPpk.MODA === '2' &&
                                        <>
                                            <Text style={styles.textEn}>Road Vehicle / </Text>
                                            <Text style={styles.textIn}>Angkutan Darat</Text>
                                        </>
                                    }
                                    {
                                        dataPpk !== null && dataPpk.MODA === '3' &&
                                        <>
                                            <Text style={styles.textEn}>Aeroplane / </Text>
                                            <Text style={styles.textIn}>Pesawat</Text>
                                        </>
                                    }
                                </View>
                            </View>
                            <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>8. Transport condition / </Text>
                                    <Text style={styles.textIn}>Kondisi transportasi : </Text>
                                    {
                                        dataPpkMutu !== null && dataPpkMutu !== undefined && dataPpkMutu.MUTU_TEMP_TIPE === '1' &&
                                        <>
                                            <Text style={styles.textEn}>Ambient / </Text>
                                            <Text style={styles.textIn}>Suhu Ruang</Text>
                                        </>
                                    }
                                    {
                                        dataPpkMutu !== null && dataPpkMutu !== undefined && dataPpkMutu.MUTU_TEMP_TIPE === '2' &&
                                        <>
                                            <Text style={styles.textEn}>Chilled / </Text>
                                            <Text style={styles.textIn}>Dingin</Text>
                                        </>
                                    }
                                    {
                                        dataPpkMutu !== null && dataPpkMutu !== undefined && dataPpkMutu.MUTU_TEMP_TIPE === '3' &&
                                        <>
                                            <Text style={styles.textEn}>Frozen / </Text>
                                            <Text style={styles.textIn}>Beku</Text>
                                        </>
                                    }
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableIdt}>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>9. Identification of transport / </Text>
                                    <Text style={styles.textIn}>Identitas alat transportasi :</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>Name of transportation / </Text>
                                    <Text style={styles.textIn}>Nama alat transportasi :</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={[styles.textEn, { paddingLeft: 7 }]}>{dataHc !== null ? dataHc.nm_trans : ''}</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>Transportation Number / </Text>
                                    <Text style={styles.textIn}>Nomor alat transportasi :</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={[styles.textEn, { paddingLeft: 7 }]}>{dataHc !== null ? dataHc.no_flight : ''}</Text>
                                </View>
                            </View>
                            <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>10. Date of departure / </Text>
                                    <Text style={styles.textIn}>Tanggal pengiriman :</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={[styles.textEn, { paddingLeft: 7 }]}>{dataHc !== null ? formatDateStringDateFirst(dataHc.tgl_berangkat) : ''}</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableIdt}>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>11. Intended uses of the product / </Text>
                                    <Text style={styles.textIn}>Tujuan penggunaan product :</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    {
                                        dataPpk !== null && dataPpk.PERUNTUKAN === '1' &&
                                        <View style={styles.tableRow}>
                                            <Text style={styles.textEn}>Human consumption / </Text>
                                            <Text style={styles.textIn}>Konsumsi manusia</Text>
                                        </View>
                                    }
                                    {
                                        dataPpk !== null && dataPpk.PERUNTUKAN === '2' &&
                                        <View style={styles.tableRow}>
                                            <Text style={styles.textEn}>Non edible / </Text>
                                            <Text style={styles.textIn}>Non pangan</Text>
                                        </View>
                                    }
                                    {
                                        dataPpk !== null && dataPpk.PERUNTUKAN === '3' &&
                                        <View style={styles.tableRow}>
                                            <Text style={styles.textEn}>Other / </Text>
                                            <Text style={styles.textIn}>Lainnya</Text>
                                        </View>
                                    }
                                </View>
                            </View>
                            <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>12. Source of raw material / </Text>
                                    <Text style={styles.textIn}>Sumber bahan baku :</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    {
                                        dataPpkMutuArea !== null && dataPpkMutuArea !== undefined && dataPpkMutuArea.MUTU_AREA === '1' &&
                                        <View style={styles.tableRow}>
                                            <Text style={styles.textEn}>Farm-Raised / </Text>
                                            <Text style={styles.textIn}>Budidaya</Text>
                                        </View>
                                    }
                                    {
                                        dataPpkMutuArea !== null && dataPpkMutuArea !== undefined && dataPpkMutuArea.MUTU_AREA === '2' &&
                                        <View style={styles.tableRow}>
                                            <Text style={styles.textEn}>Wild-Caught / </Text>
                                            <Text style={styles.textIn}>Tangkap</Text>
                                        </View>
                                    }
                                    {
                                        dataPpkMutuArea !== null && dataPpkMutuArea !== undefined && dataPpkMutuArea.MUTU_AREA === '3' &&
                                        <View style={styles.tableRow}>
                                            <Text style={styles.textEn}>Import / </Text>
                                            <Text style={styles.textIn}>Impor</Text>
                                        </View>
                                    }
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableIdt}>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol1, { borderRightWidth: 1 }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>13. Producing Establishment / </Text>
                                    <Text style={styles.textIn}>Unit Usaha :</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>Name / </Text>
                                    <Text style={styles.textIn}>Nama : </Text>
                                    <Text style={styles.textEn}>{dataHc !== null ? dataHc.nm_upi : ''}</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>Address / </Text>
                                    <Text style={styles.textIn}>Alamat : </Text>
                                </View>
                                <View style={styles.tableCol}>
                                    <Text style={styles.textEn}>{dataHc !== null ? dataHc.al_upi : ''}</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>Establishment identity number / </Text>
                                    <Text style={styles.textIn}>Nomor Identitas unit usaha : </Text>
                                </View>
                                <View style={styles.tableCol}>
                                    <Text style={styles.textEn}>{dataHc !== null ? dataHc.no_reg_upi : ''}</Text>
                                </View>
                            </View>
                            <View style={[styles.tableCol2, { borderRightWidth: 1 }]}>
                                <View style={styles.tableIdt2}>
                                    <View style={styles.tableRow}>
                                        <Text style={styles.textEn}>14. Total Weight (kg) / </Text>
                                        <Text style={styles.textIn}>Jumlah berat (kg) :</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.textEn}>{dataHc !== null ? dataHc.netto : ''} Kgm </Text>
                                    </View>
                                </View>
                                <View style={styles.tableIdt2}>
                                    <View style={styles.tableRow}>
                                        <Text style={styles.textEn}>15. Total number and type of Packages / </Text>
                                        <Text style={styles.textIn}>Jumlah dan jenis kemasan : </Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.textEn}>{jumlahKemasan !== undefined && jumlahKemasan !== null ? (<>{jumlahKemasan} {uraianKemasan}</>) : 0}</Text>
                                    </View>
                                </View>
                                <View style={[styles.tableIdt2, { borderBottom: 0 }]}>
                                    <View style={styles.tableRow}>
                                        <Text style={styles.textEn}>16. Container and Seal Number  / </Text>
                                        <Text style={styles.textIn}>Nomor Kontainer dan Seal : </Text>
                                    </View>
                                    {
                                        dataPpkContainer !== undefined && dataPpkContainer !== null &&
                                        dataPpkContainer.map((kont, index) => {
                                            return (
                                                <>
                                                    <View key={index} style={styles.tableCol}>
                                                        <Text style={styles.textEn}>
                                                            {kont.NOMOR} / {kont.NOMOR_SEGEL}
                                                        </Text>
                                                    </View>
                                                </>
                                            )
                                        })
                                    }
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableIdt}>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { width: "4%", borderRightWidth: 1 }]}>
                                <Text style={styles.text}>No.</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "23%", borderRightWidth: 1 }]}>
                                <Text style={styles.text}>Products Description</Text>
                                <Text style={styles.italicText}>Deskripsi produk</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "23%", borderRightWidth: 1 }]}>
                                <Text style={styles.text}>Common and Scientific Name</Text>
                                <Text style={styles.italicText}>Nama umum dan latin</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "19%", borderRightWidth: 1 }]}>
                                <Text style={styles.text}>Quantiry (kg) / (hds)</Text>
                                <Text style={styles.italicText}>Quantity (kg) / (ekor)</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "20%", borderRightWidth: 1 }]}>
                                <Text style={styles.text}>Number of packages</Text>
                                <Text style={styles.italicText}>Jumlah kemasan</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "20%", borderRightWidth: 1 }]}>
                                <Text style={styles.text}>Type of packaging</Text>
                                <Text style={styles.italicText}>Jenis kemasan</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "16%", borderRightWidth: 1 }]}>
                                <Text style={styles.text}>Batch number</Text>
                                <Text style={styles.italicText}>Nomor Batch</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "17%", borderRightWidth: 1 }]}>
                                <Text style={styles.text}>Date of production</Text>
                                <Text style={styles.italicText}>Tanggal produksi</Text>
                            </View>
                        </View>
                        {
                            dataPpkDetail !== undefined && dataPpkDetail !== null && dataPpkDetail.length <= 3 ?
                                (
                                    dataPpkDetail.map((detil, index) => {
                                        return (
                                            <>
                                                <View key={index} style={[styles.tableRow]}>
                                                    <View style={[styles.tableCol, { width: "4%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                        <Text style={styles.text}>{detil.SERI}</Text>
                                                    </View>
                                                    {
                                                        index === 0 ?
                                                            (
                                                                <View style={[styles.tableCol, { width: "23%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                                    <Text style={[styles.text]}>{dataPpkMutu !== null && dataPpkMutu !== undefined && dataPpkMutu.MUTU_DESK}</Text>
                                                                </View>
                                                            ) :
                                                            (
                                                                <View style={[styles.tableCol, { width: "23%", borderRightWidth: 1, borderTopWidth: 0 }]} />
                                                            )
                                                    }
                                                    <View style={[styles.tableCol, { width: "23%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                        <Text style={[styles.text]}>{detil.NAMA_UMUM} / </Text>
                                                        <Text style={[styles.text]}>{detil.NAMA_LATIN}</Text>
                                                    </View>
                                                    <View style={[styles.tableCol, { width: "19%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                        <Text style={[styles.text]}>{detil.JUMLAH}</Text>
                                                    </View>
                                                    {
                                                        index === 0 ?
                                                            (
                                                                <>
                                                                    <View style={[styles.tableCol, { width: "20%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                                        <Text style={[styles.text]}>{jumlahKemasan}</Text>
                                                                    </View>
                                                                    <View style={[styles.tableCol, { width: "20%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                                        <Text style={[styles.text]}>{uraianKemasan}</Text>
                                                                    </View>
                                                                    <View style={[styles.tableCol, { width: "16%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                                        {
                                                                            dataPpkMutuProd.map((mutuProd, index) => {
                                                                                return (
                                                                                    <Text key={index} style={[styles.text]}>
                                                                                        {mutuProd.MUTU_PROD_NO}
                                                                                    </Text>
                                                                                )
                                                                            })
                                                                        }
                                                                    </View>
                                                                    <View style={[styles.tableCol, { width: "17%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                                        {
                                                                            dataPpkMutuProd.map((mutuProd, index) => {
                                                                                return (
                                                                                    <Text key={index} style={[styles.text]}>
                                                                                        {mutuProd.MUTU_PROD_TGL}
                                                                                    </Text>
                                                                                )
                                                                            })
                                                                        }
                                                                    </View>
                                                                </>
                                                            ) :
                                                            (
                                                                <>
                                                                    <View style={[styles.tableCol, { width: "20%", borderRightWidth: 1 }]}>
                                                                        <Text style={[styles.text]}></Text>
                                                                    </View>
                                                                    <View style={[styles.tableCol, { width: "20%", borderRightWidth: 1 }]}>
                                                                        <Text style={[styles.text]}></Text>
                                                                    </View>
                                                                    <View style={[styles.tableCol, { width: "16%", borderRightWidth: 1 }]}>
                                                                        <Text style={[styles.text]}></Text>
                                                                    </View>
                                                                    <View style={[styles.tableCol, { width: "17%", borderRightWidth: 1 }]}>
                                                                        <Text style={[styles.text]}></Text>
                                                                    </View>
                                                                </>
                                                            )
                                                    }
                                                </View>

                                            </>
                                        )
                                    })
                                ) :
                                (
                                    <>
                                        <View style={[styles.tableRow]}>
                                            <View style={[styles.tableCol, { width: "4%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                <Text style={styles.text}></Text>
                                            </View>
                                            <View style={[styles.tableCol, { width: "23%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                <Text style={[styles.text]}>See Appendix</Text>
                                            </View>
                                            <View style={[styles.tableCol, { width: "23%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                <Text style={[styles.text]}></Text>
                                            </View>
                                            <View style={[styles.tableCol, { width: "19%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                <Text style={[styles.text]}></Text>
                                            </View>
                                            <View style={[styles.tableCol, { width: "20%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                <Text style={[styles.text]}></Text>
                                            </View>
                                            <View style={[styles.tableCol, { width: "20%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                <Text style={[styles.text]}></Text>
                                            </View>
                                            <View style={[styles.tableCol, { width: "16%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                <Text style={[styles.text]}></Text>
                                            </View>
                                            <View style={[styles.tableCol, { width: "17%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                <Text style={[styles.text]}></Text>
                                            </View>
                                        </View>
                                    </>
                                )
                        }
                    </View>
                    <View style={[styles.tableIdt, { borderRightWidth: 1 }]}>
                        <View style={styles.tableRow}>
                            <Text style={[styles.textEn, { fontSize: 10 }]}>Attestation / </Text>
                            <Text style={[styles.textIn, { fontSize: 10 }]}>Pernyataan</Text>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={styles.tableCol}>
                                <Text style={styles.textEn}>The undersigned Certifying Official certifies that the product(s) described above satisfy(s) the following requirements/ </Text>
                                <Text style={styles.textIn}>Pejabat penandatangan sertifikat di bawah ini menyatakan bahwa produk yang diuraikan di atas memenuhi persyaratan berikut :</Text>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { width: "1%" }]}>
                                <Image style={styles.checkicon} src={imgCheckbox} />
                            </View>
                            <View style={[styles.tableCol, { width: "3%", marginLeft: 10 }]}>
                                <Text style={styles.textEn}>a.</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={styles.textEn}>The Product from each batch described above have been processed, inspected and graded in (an) establishment(s) that has been approved by and under control of the Competent Authority </Text>
                                <Text style={styles.textIn}>Produk telah diproses, diinspeksi dan dinilai di unit usaha yang telah mendapat persetujuan dan dilakukan pengawasan oleh Otoritas Kompeten</Text>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { width: "1%" }]}>
                                {
                                    dataPpkMutu !== null && dataPpkMutu !== undefined && dataPpkMutu.upiRegNo !== null ?
                                        <Image style={styles.checkicon} src={imgCheckbox} /> : <Image style={styles.checkicon} src={imgCheckboxBlank} />
                                }
                            </View>
                            <View style={[styles.tableCol, { width: "3%", marginLeft: 10 }]}>
                                <Text style={styles.textEn}>b.</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={styles.textEn}>have been handled, prepared or processed, identified, stored and transported under a competent HACCP and sanitary programme consistently implemented and in accordance with the requirements laid down in Codex Code of Practice for Fish and Fishery Products (CAC/RCP 52-2003)</Text>
                                <Text style={styles.textIn}>telah ditangani, disiapkan atau proses, diidentifikasi, disimpan dan ditransportasikan sesuai persyaratan sanitasi dan HACCP yang diterapkan secara konsisten dan sesuai dengan persyaratan yang ditetapkan Codex Code of Practice for Fish and Fishery Products. (CAC/RCP 52-2003)</Text>
                            </View>
                        </View>
                        {
                            dataPpkMutu !== null && dataPpkMutu !== undefined && dataPpkMutu.addInfo !== null && dataPpkMutu.addInfo !== '' &&
                            <>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.textEn}>Additional Information : </Text>
                                    </View>
                                </View>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.textEn}>{dataPpkMutu.addInfo}</Text>
                                    </View>
                                </View>
                            </>
                        }
                    </View>
                    <View style={styles.tableIdt}>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>QR CODE</Text>
                                </View>
                                {/* {qrImage && (
                                    <View style={styles.qrCode}>
                                        <Image src={qrImage} style={{ width: 60, height: 60 }} />
                                    </View>
                                )} */}
                            </View>
                            <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.textEn}>Date of Issue / </Text>
                                    <Text style={styles.textIn}>Dikeluarkan tanggal : </Text>
                                    <Text style={styles.textEn}>{upt !== null ? upt.KOTA : ''}, {dataHc !== null ? formatDateStringDateFirst(dataHc.tgl_hc) : ''}</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableCol}>
                                        <Text style={[styles.textEn, { textAlign: "center" }]}></Text>
                                    </View>
                                </View>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableCol}>
                                        <Text style={[styles.textEn, { textAlign: "center" }]}></Text>
                                    </View>
                                </View>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableCol}>
                                        <Text style={[styles.textEn, { textAlign: "center" }]}></Text>
                                    </View>
                                </View>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableCol}>
                                        <Text style={[styles.textEn, { textAlign: "center" }]}></Text>
                                    </View>
                                </View>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableCol}>
                                        <Text style={[styles.textEn, { textAlign: "center" }]}></Text>
                                    </View>
                                </View>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableCol}>
                                        <Text style={[styles.textEn, { textAlign: "center" }]}></Text>
                                    </View>
                                </View>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableCol}>
                                        <Text style={[styles.textEn, { textAlign: "center" }]}>Signature of the  Official Inspector</Text>
                                        <Text style={[styles.textIn, { textAlign: "center" }]}>Tanda tangan Inspektur Mutu</Text>
                                    </View>
                                </View>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableCol}>
                                        <Text style={[styles.textEn, { textAlign: "center" }]}>{dataHc !== null ? dataHc.nm_pejabat : ''}</Text>
                                    </View>
                                </View>
                            </View>
                        </View>
                    </View>
                </Page>
                {
                    dataPpkDetail !== undefined && dataPpkDetail !== null && dataPpkDetail.length > 3 &&
                    <>
                        {/* <DraftAppendix ppmdetil={dataPpkDetail} datahc={dataHc} qrImage={qrImage} /> */}
                        <DraftAppendix ppmdetil={dataPpkDetail} datahc={dataHc} />
                    </>
                }
            </Document>
        </PDFViewer>
    )
}

export default FormH;
